/**
 * Constants declaration
 */
import versionData from '../version.json';

export const
    AUTHOR = 'AUDITUM AG',
    WEBSITE = "https://www.auditum.de/",
    SUPPORT = "support@prodatec.de",
    VERSION = versionData.client_version,
    RELEASE = versionData.version_date,

    // Run app in DEBUG mode (more console and alert messages)
    DEBUG_MODE = false,

    // Disable dragging of the timeline canvas
    TIMELINE_NO_DRAG = true,

    // HTTP GET/POST/PUT for API connection
    API_URL = "/api",

    // Length of visible part of token
    TOKEN_LENGTH = 8,

    // HTTP response status codes URL (with final /)
    HTTP_STATUS_URL = "https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/";

// Welcome message if DEBUG
if (DEBUG_MODE) {
    console.info(`Kunden-Portal ${VERSION} by ${AUTHOR}\n\nAPI: ${API_URL}\n*** Debug mode activated ***`);
}
